var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-table-column", {
    key: _vm.code,
    attrs: { label: _vm.name, "min-width": 200, fixed: false, align: "center" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [
            _c("ik-table-data-popup", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.edit,
                  expression: "edit",
                },
              ],
              ref: "input_" + scope.$index + "_" + "code",
              attrs: {
                line: scope.$index,
                code: _vm.code,
                name: _vm.name,
                "default-value": _vm.defaultValue,
                require: _vm.getRequire,
                url: _vm.findUrl,
                "filed-list": _vm.filedList,
                "search-key": _vm.searchKey,
                searcher: _vm.searcher,
                "page-sign": _vm.pageSign,
                rules: _vm.rules,
              },
              on: {
                onFieldChange: _vm.onFieldChange,
                onPopupClick: _vm.onPopupClick,
              },
              model: {
                value: scope.row[_vm.code],
                callback: function ($$v) {
                  _vm.$set(scope.row, _vm.code, $$v)
                },
                expression: "scope.row[code]",
              },
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.edit,
                    expression: "!edit",
                  },
                ],
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.message[scope.$index]) +
                    " " +
                    _vm._s(_vm.errorSign[scope.$index]) +
                    " " +
                    _vm._s(scope.row[_vm.code]) +
                    " "
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }